import React, { useEffect, useState } from "react";
import { Edit2, Trash2, Save, X, Plus, Link2 } from "lucide-react";
import { baseURL } from "../network/baseUrl";
import {
  deleteProtected,
  getProtected,
  putProtected,
} from "../network/ApiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const ContractHistoryTable = ({
  t = () => {},
  id = "",
  refreshContracts = false,
  isEditable = true,
  transportUrl,
  isValidUrl,
}) => {
  // Replace with your actual base URL

  const navigate = useNavigate();

  const initialData = [
    {
      contract_start: "2024-11-01",
      status: "active",
      contract_price_euro: "750.50",
      contract_number: "9aa0c1e3-0a8a-4b52-b5d0-d1deb8678c6f",
      contract_end: "2027-10-31",
      contract_type: "leasing",
      created_at: "2025-06-26T16:18:59.326787Z",
      updated_at: "2025-06-26T16:18:59.326799Z",
      customer: {
        name: "Global Logistics Inc.",
        email: "procurement@globallogistics.com",
        phone_number: "+49 30 12345678",
        address: "Logistik-Allee 1, 10115 Berlin, Germany",
        customer_manager: 1,
        customer_company: "Global Logistics Inc.",
        customer_number: "001",
      },
      invoice_address_street: "Logistik-Allee 1",
      invoice_address_zip: "10115",
      invoice_address_city: "Berlin",
      invoice_address_country: "Germany",
    },
    {
      contract_start: "2025-01-01",
      status: "completed",
      contract_price_euro: "5000.00",
      contract_number: "3eba6068-5ca5-41b5-9997-a996e540c027",
      contract_end: "2025-12-31",
      contract_type: "sale",
      created_at: "2025-06-27T06:20:38.055197Z",
      updated_at: "2025-06-27T08:07:10.653388Z",
      customer: null,
      invoice_address_street: null,
      invoice_address_zip: null,
      invoice_address_city: null,
      invoice_address_country: null,
    },
  ];

  const [contracts, setContracts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const getContractHistory = async () => {
    if (!id) return;
    try {
      const url = `${baseURL}/contract-asset/history/${id}`;
      if (!url) {
        throw new Error("API endpoint not defined");
      }
      const response = await getProtected(url);
      console.log("response = ", response);
      if (Array.isArray(response) && response?.length > 0) {
        setContracts(response);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }
      toast.error(t("dashboardToasters.genricError"));
    }
  };

  useEffect(() => {
    getContractHistory();
  }, [refreshContracts]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      active: "bg-green-100 text-green-800",
      completed: "bg-blue-100 text-blue-800",
      cancelled: "bg-red-100 text-red-800",
      pending: "bg-yellow-100 text-yellow-800",
    };

    return (
      <span
        className={`px-2 py-1 rounded-full text-xs font-medium ${
          statusColors[status] || "bg-gray-100 text-gray-800"
        }`}
      >
        {status?.charAt(0).toUpperCase() + status?.slice(1) || "Unknown"}
      </span>
    );
  };

  const getTypeBadge = (type) => {
    const typeColors = {
      leasing: "bg-purple-100 text-purple-800",
      sale: "bg-orange-100 text-orange-800",
      rental: "bg-teal-100 text-teal-800",
      demo: "bg-cyan-100 text-cyan-800",
      maintenance: "bg-orange-100 text-orange-800",
    };

    return (
      <span
        className={`px-2 py-1 rounded-full text-xs font-medium ${
          typeColors[type] || "bg-gray-100 text-gray-800"
        }`}
      >
        {type?.charAt(0).toUpperCase() + type?.slice(1) || "Unknown"}
      </span>
    );
  };

  const handleEdit = (contract) => {
    setEditData({
      ...contract,
      customer_name: contract.customer?.name || "",
      customer_email: contract.customer?.email || "",
      customer_phone: contract.customer?.phone_number || "",
      customer_company: contract.customer?.customer_company || "",
      customer_number: contract.customer?.customer_number || "",
    });
    setIsModalOpen(true);
    setError(null);
  };

  const updateContract = async (contractNumber, contractData) => {
    // const id = "fe322ed6-b829-4221-89e5-aed045aa30eb";
    const url = `${baseURL}/contract/history/${contractNumber}`;
    try {
      const response = await putProtected(url, JSON.stringify(contractData));
      console.log("response = ", response);
      const updatedData = response?.data;
      toast.success(t("dashboardToasters.contractUpdatedSuccessfully"));

      return updatedData;
    } catch (error) {
      console.error("Error updating contract:", error);
      throw error;
    }
    // finally {
    //   navigate("/dashboard");
    // }
  };

  const formatContractForAPI = (editData) => {
    return {
      customer: {
        name: editData.customer_name || "",
        phone_number: editData.customer_phone || "",
        email: editData.customer_email || "",
        customer_company: editData.customer_company || "",
        customer_number: editData.customer_number || "",
      },
      contract_type: editData.contract_type || "",
      contract_start: editData.contract_start || "",
      contract_end: editData.contract_end || "",
      contract_price_euro: editData.contract_price_euro || "",

      invoice_address_street: editData.invoice_address_street || "",
      invoice_address_zip: editData.invoice_address_zip || "",
      invoice_address_city: editData.invoice_address_city || "",
      invoice_address_country: editData.invoice_address_country || "",

      delivery_address_street: editData.delivery_address_street || "",
      delivery_address_zip: editData.delivery_address_zip || "",
      delivery_address_city: editData.delivery_address_city || "",
      delivery_address_country: editData.delivery_address_country || "",
    };
  };

  const handleSave = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const contractData = formatContractForAPI(editData);
      console.log("contract data =", contractData);

      await updateContract(editData.contract_number, contractData);
      setContracts(
        contracts.map((contract) => {
          if (contract.contract_number === editData.contract_number) {
            return {
              ...editData,
              customer: editData.customer_name
                ? {
                    name: editData.customer_name,
                    email: editData.customer_email,
                    phone_number: editData.customer_phone,
                    customer_company: editData.customer_company,
                    customer_number: editData.customer_number,
                    customer_manager: contract.customer?.customer_manager || 1,
                  }
                : null,
              updated_at: new Date().toISOString(),
            };
          }
          return contract;
        })
      );

      setIsModalOpen(false);
      setEditData({});
    } catch (error) {
      // catch (error) {
      //   setError(`Failed to update contract: ${error.message}`);
      // }
      console.error("Update contract error:", error);

      if (error.response?.status === 400) {
        const errorData = error.response?.data;
        if (errorData?.customer?.customer_number) {
          setError("Customer with this number already exists.");
        } else {
          setError(`Validation error: ${JSON.stringify(errorData)}`);
        }
      } else if (error.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      } else {
        setError(`Failed to update contract: ${error.message}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setEditData({});
    setError(null);
  };

  const handleDelete = async (contractNumber) => {
    setContracts(
      contracts.filter(
        (contract) => contract.contract_number !== contractNumber
      )
    );

    try {
      const url = `${baseURL}/contract/history/${contractNumber}`;
      await deleteProtected(url);
      toast.success(t("dashboardToasters.contractDeletedSuccessfully"));
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }
      console.error(e);
      const message = e?.response?.data?.messages;
      if (message?.[0]?.message) {
        toast.error(t("dashboardToasters.genricError"));
      }
    } finally {
    }
  };

  useEffect(() => {
    console.log("edit data = ", editData);
  }, []);

  const handleInputChange = (field, value) => {
    setEditData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="p-6 bg-gray-50 max-h-400px">
      <div className="max-w-full mx-auto">
        <div className="mb-6">
          <h1 className="text-md font-medium mb-3 text-gray-700">
            {t("contractHistoryModal.contractHistory")}
          </h1>
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {t("contractHistoryModal.customerInformation")}
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {t("contractHistoryModal.contractPeriod")}
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {t("contractHistoryModal.type")}
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {t("contractHistoryModal.price")}
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {t("contractHistoryModal.lastUpdated")}
                  </th>
                  {isEditable && (
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      {t("contractHistoryModal.actions")}
                    </th>
                  )}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {contracts.map((contract) => {
                  const url =
                    contract.transport_order_url || transportUrl || "";
                  const normalizedUrl = url
                    ? (() => {
                        try {
                          new URL(url);
                          return url;
                        } catch {
                          return `https://${url}`;
                        }
                      })()
                    : "";

                  return (
                    <tr
                      key={contract.contract_number}
                      className="hover:bg-gray-50"
                    >
                      <td className="px-6 py-4">
                        <div>
                          {contract.customer ? (
                            <>
                              <div className="text-sm font-medium text-gray-900">
                                {contract.customer.name}
                              </div>
                              <div className="text-sm text-gray-500">
                                {contract.customer.email}
                              </div>
                              <div className="text-sm text-gray-500">
                                {contract.customer.phone_number}
                              </div>
                              <div className="text-sm text-gray-500">
                                {contract.customer.customer_company}
                              </div>
                            </>
                          ) : (
                            <span className="text-sm text-gray-400">
                              {t("contractHistoryModal.noCustomerData")}
                            </span>
                          )}
                        </div>
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        <div>
                          <div className="text-sm text-gray-900">
                            <strong> {t("contractHistoryModal.start")}:</strong>{" "}
                            {formatDate(contract.contract_start)}
                          </div>
                          <div className="text-sm text-gray-900">
                            <strong> {t("contractHistoryModal.end")}:</strong>{" "}
                            {formatDate(contract.contract_end)}
                          </div>
                        </div>
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="space-y-2">
                          {getTypeBadge(contract.contract_type)}
                        </div>
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        {/* <div className="text-sm font-medium text-gray-900">
                        €
                        {parseFloat(
                          contract.contract_price_euro
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div> */}
                        <div className="text-sm font-medium text-gray-900">
                          €
                          {isNaN(parseFloat(contract.contract_price_euro)) ||
                          contract.contract_price_euro === null ||
                          contract.contract_price_euro === ""
                            ? "-"
                            : parseFloat(
                                contract.contract_price_euro
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                        </div>
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {formatDateTime(contract.updated_at)}
                      </td>

                      {isEditable && (
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <div className="flex space-x-2">
                            <button
                              type="button"
                              onClick={() => handleEdit(contract)}
                              className="text-indigo-600 hover:text-indigo-900 flex items-center"
                            >
                              <Edit2 className="h-4 w-4" />
                            </button>
                            <button
                              type="button"
                              onClick={() =>
                                handleDelete(contract.contract_number)
                              }
                              className="text-red-600 hover:text-red-900 flex items-center"
                            >
                              <Trash2 className="h-4 w-4" />
                            </button>
                            {/* Removed link icon button */}
                          </div>
                        </td>
                      )}
  {/* Removed Transport Order History Modal */}

                      {/* {url && isValidUrl(url) && (
          <tr>
            <td colSpan={isEditable ? 6 : 5}>
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-x-2 mb-3 mt-4">
                <div className="lg:col-span-4">
                  <div className="flex items-center gap-2">
                    <span className="text-md font-medium text-gray-700">
                      {t("createAsset.placeholders.transportUrlLabel") ||
                        "Transport Order URL"}
                      :
                    </span>
                    <a
                      href={normalizedUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline break-all"
                      title={normalizedUrl}
                    >
                      {url}
                    </a>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        )} */}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-4 flex justify-between items-center">
          <div className="text-sm text-gray-500">
            {t("contractHistoryModal.showing")} {contracts.length}{" "}
            {t("contractHistoryModal.contract")}
            {contracts.length !== 1 ? "s" : ""}
          </div>
          {/* <div className="text-sm text-gray-500">
            Last updated: {new Date().toLocaleString()}
          </div> */}
        </div>
      </div>

      {/* Edit Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center  z-[10000]">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 h-[85] overflow-y-auto">
            <div className="px-6 py-4 border-b border-gray-200 ">
              <div className="flex items-center justify-between ">
                <h2 className="text-lg font-medium text-gray-900   ">
                  {t("contractHistoryModal.editContract") || "Edit Contract"}
                </h2>
                <button
                  onClick={handleCancel}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>

            {error && (
              <div className="px-6 py-4 bg-red-50 border-b border-red-200">
                <div className="text-sm text-red-600">{error}</div>
              </div>
            )}

            <div className="px-6 py-4">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6 ">
                {/* Customer Information */}
                <div className="space-y-4">
                  <h3 className="text-sm font-medium text-gray-700 mb-3">
                    {t("contractHistoryModal.customerInformation")}
                  </h3>
                  <input
                    type="text"
                    value={editData.customer_name || ""}
                    onChange={(e) =>
                      handleInputChange("customer_name", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Customer Name"
                  />
                  <input
                    type="email"
                    value={editData.customer_email || ""}
                    onChange={(e) =>
                      handleInputChange("customer_email", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Email"
                  />
                  <input
                    type="tel"
                    value={editData.customer_phone || ""}
                    onChange={(e) =>
                      handleInputChange("customer_phone", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Phone"
                  />
                  <input
                    type="text"
                    value={editData.customer_company || ""}
                    onChange={(e) =>
                      handleInputChange("customer_company", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Customer Company"
                  />
                  <input
                    type="text"
                    value={editData.customer_number || ""}
                    onChange={(e) =>
                      handleInputChange("customer_number", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Customer Number"
                  />
                </div>

                {/* Contract Details */}
                <div className="space-y-4">
                  <h3 className="text-sm font-medium text-gray-700">
                    {t("contractHistoryModal.contractDetails")}
                  </h3>
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">
                      {t("contractHistoryModal.start")}
                    </label>
                    <input
                      type="date"
                      value={editData.contract_start || ""}
                      onChange={(e) =>
                        handleInputChange("contract_start", e.target.value)
                      }
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">
                      {t("contractHistoryModal.end")}
                    </label>
                    <input
                      type="date"
                      value={editData.contract_end || ""}
                      onChange={(e) =>
                        handleInputChange("contract_end", e.target.value)
                      }
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">
                      {t("contractHistoryModal.type")}
                    </label>
                    <select
                      value={editData.contract_type || ""}
                      onChange={(e) =>
                        handleInputChange("contract_type", e.target.value)
                      }
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      <option value="">
                        {t("contractHistoryModal.selectType")}
                      </option>
                      <option value="leasing">Leasing</option>
                      <option value="sale">Sale</option>
                      <option value="rental">Rental</option>
                      <option value="demo">Demo</option>
                      <option value="maintenance">Maintenance</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">
                      {t("contractHistoryModal.price")}
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      value={editData.contract_price_euro || ""}
                      onChange={(e) =>
                        handleInputChange("contract_price_euro", e.target.value)
                      }
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      placeholder="Price"
                    />
                  </div>
                </div>

                {/* Invoice Address */}
                <div className="space-y-4">
                  <h3 className="text-sm font-medium text-gray-700 mb-3">
                    {t("contractHistoryModal.invoiceAddress")}
                  </h3>
                  <input
                    type="text"
                    value={editData.invoice_address_street || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "invoice_address_street",
                        e.target.value
                      )
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Street Address"
                  />
                  <input
                    type="text"
                    value={editData.invoice_address_zip || ""}
                    onChange={(e) =>
                      handleInputChange("invoice_address_zip", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="ZIP Code"
                  />
                  <input
                    type="text"
                    value={editData.invoice_address_city || ""}
                    onChange={(e) =>
                      handleInputChange("invoice_address_city", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="City"
                  />
                  <input
                    type="text"
                    value={editData.invoice_address_country || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "invoice_address_country",
                        e.target.value
                      )
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Country"
                  />
                </div>

                <div className="space-y-4">
                  <h3 className="text-sm font-medium text-gray-700 mb-3">
                    {t("contractHistoryModal.deliveryAddress")}
                  </h3>
                  <input
                    type="text"
                    value={editData.delivery_address_street || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "delivery_address_street",
                        e.target.value
                      )
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Street Address"
                  />
                  <input
                    type="text"
                    value={editData.delivery_address_zip || ""}
                    onChange={(e) =>
                      handleInputChange("delivery_address_zip", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="ZIP Code"
                  />
                  <input
                    type="text"
                    value={editData.delivery_address_city || ""}
                    onChange={(e) =>
                      handleInputChange("delivery_address_city", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="City"
                  />
                  <input
                    type="text"
                    value={editData.delivery_address_country || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "delivery_address_country",
                        e.target.value
                      )
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Country"
                  />
                </div>
              </div>
            </div>

            <div className="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3">
              <button
                onClick={handleCancel}
                disabled={isLoading}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300  hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-50"
              >
                {t("common.cancel")}
              </button>
              <button
                onClick={handleSave}
                className={`bg-blue-600 hover:bg-blue-700 text-white px-4 py-2  text-sm sm:text-base w-full sm:w-auto ${
                  isLoading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={isLoading}
              >
                {t("common.buttons.save")}
              </button>
            </div>
          </div>
        </div>
      )}
    {/* Render all transport order links below the contract history table */}
    <div className="mt-6">
      <h2 className="text-md font-medium text-gray-700 mb-2">Transport Order Links</h2>
      {contracts && contracts.length > 0 ? (
        <ul className="space-y-2">
          {contracts.map((contract, idx) => (
            contract.transport_order_history && contract.transport_order_history.length > 0 ? (
              contract.transport_order_history.map((item, tidx) => (
                <li key={idx + '-' + tidx} className="flex items-center space-x-2">
                  <a
                    href={item.transport_order_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline break-all"
                  >
                    {item.transport_order_url}
                  </a>
                  <span className="text-xs text-gray-400">{formatDateTime(item.uploaded_at)}</span>
                </li>
              ))
            ) : null
          ))}
        </ul>
      ) : (
        <div className="text-gray-500">No transport order links found.</div>
      )}
    </div>
  </div>
  );
};

export default ContractHistoryTable;
